import { useSelector } from "react-redux";
import GameInstructionsPopup from "../GameInstructionsPopup/GameInstructionsPopup";
import "./EntityInfoDisplay.css";
import Button from "../Button/Button";

const EntityInfoDisplay = () => {
  const openPopup = useSelector((state) => state.game.popup.open);
  const replay = useSelector((state) => state.game.replay);

  return (
    <>
      {!replay && (
        <div
          className="game-instructions-container"
          data-testid="game-instructions"
        >
          <div
            style={{
              backgroundColor: "red",
              borderRadius: "9999px",
              padding: "0.6em 1.4em", 
              display: "inline-flex", 
              alignItems: "center",
              justifyContent: "center",
              maxWidth: "100%", 
              overflow: "hidden", 
            }}
          >
            <h2
              className="animate-character"
              style={{
                margin: 0,
                whiteSpace: "nowrap",
              }}
            >
              INFILTRATION COUNTDOWN
            </h2>
          </div>

          <h3>SH-141 Fighter Battleship</h3>
          <div className="ship-info-container">
            <div className="ship-info">
              <img src={"https://dawn-unit-97b0.sdrowvieli1.workers.dev/infiltration/images/spaceship.webp"} alt="Player ship" />
            </div>
            <ul style={{ textAlign: "left" }}>
              <li>
                Description: The Starhawk Infiltrator is a nimble and fast
                spacecraft designed for hit-and-run tactics
              </li>
            </ul>
          </div>
          <h3>Light Enemy Battleship</h3>
          <div className="ship-info-container">
            <div className="ship-info">
              <img src={"https://dawn-unit-97b0.sdrowvieli1.workers.dev/infiltration/images/ship13.webp"} alt="Small enemy ship" />
            </div>
            <ul style={{ textAlign: "left" }}>
              <li>
                Description: The Blackhawk Marauder is a swift and agile enemy
                battleship, designed for hit-and-run tactics.
              </li>
            </ul>
          </div>
          <h3>Heavy Enemy Battleship</h3>
          <div className="ship-info-container">
            <div className="big-ship-info">
              <img src={"https://dawn-unit-97b0.sdrowvieli1.workers.dev/infiltration/images/ship15.webp"} alt="Big enemy ship" />
            </div>
            <ul style={{ textAlign: "left" }}>
              <li>
                Description: The Void Leviathan is a colossal enemy battleship,
                heavily armored and armed with devastating plasma cannons
              </li>
            </ul>
          </div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Button type="instructions" style={{}} />
            {openPopup && <GameInstructionsPopup />}
          </div>
        </div>
      )}
    </>
  );
};

export default EntityInfoDisplay;
